import { ROLE_ADMIN, ROLE_MEMBER, ROLE_MODERATOR, ROLE_NONE, ROLE_OWNER } from "../constants";
export const allRoles = [ROLE_OWNER, ROLE_ADMIN, ROLE_MODERATOR, ROLE_MEMBER, ROLE_NONE];
export const chatRoles = allRoles;
export const communityRoles = [ROLE_OWNER, ROLE_ADMIN, ROLE_MEMBER];
export const messagePermissionsList = [
    "text",
    "image",
    "video",
    "audio",
    "file",
    "poll",
    "crypto",
    "giphy",
    "prize",
    "memeFighter",
    "p2pSwap",
];
export const chatPermissionsList = [
    "changeRoles",
    "updateGroup",
    "inviteUsers",
    "addMembers",
    "removeMembers",
    "deleteMessages",
    "pinMessages",
    "reactToMessages",
    "mentionAllMembers",
    "startVideoCall",
];
export const communityPermissionsList = [
    "changeRoles",
    "updateDetails",
    "inviteUsers",
    "removeMembers",
    "createPublicChannel",
    "createPrivateChannel",
    "manageUserGroups",
];
export const botChatPermissionList = [
    "changeRoles",
    "updateGroup",
    "addMembers",
    "inviteUsers",
    "removeMembers",
    "deleteMessages",
    "pinMessages",
    "reactToMessages",
    "mentionAllMembers",
    "startVideoCall",
    "readMessages",
    "readMembership",
    "readChatSummary",
];
export const botCommunityPermissionList = [
    "changeRoles",
    "updateDetails",
    "inviteUsers",
    "removeMembers",
    "createPublicChannel",
    "createPrivateChannel",
    "manageUserGroups",
    "readMembership",
    "readCommunitySummary",
];
export function defaultOptionalChatPermissions() {
    return {
        messagePermissions: undefined,
        threadPermissions: undefined,
    };
}
export function defaultOptionalMessagePermissions() {
    return {
        default: undefined,
        text: undefined,
        image: undefined,
        video: undefined,
        audio: undefined,
        file: undefined,
        poll: undefined,
        crypto: undefined,
        giphy: undefined,
        prize: undefined,
        memeFighter: undefined,
        p2pSwap: undefined,
    };
}
